/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_Calc_Extra_StorageInputs */



/**
* | output |
* | --- |
* | "Extra storage" |
*
* @param {Cost_Calc_Extra_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_calc_extra_storage = /** @type {((inputs?: Cost_Calc_Extra_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Calc_Extra_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusatzspeicher")
	return /** @type {LocalizedString} */ ("Extra storage")
});